exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.merchant-wrap .claim {\n  padding: 0 !important;\n  height: auto;\n  max-height: calc(74vh - 3.15rem) !important;\n  overflow: auto !important;\n}\n.merchant-wrap .titleBox div {\n  font-family: PingFangSC-Medium;\n  font-size: 0.8rem;\n  color: #333333;\n  letter-spacing: 0;\n  text-align: center;\n  font-weight: bold;\n}", ""]);

// exports
